// Frontend ve backend'in ortak sözleşmesi.
// Buraya konan her şey iki tarafta da derlenmeli — Node'a özgü import yok.
//
// Sıra bağımlılık sırası: env/enums/plans hiçbir şeye dayanmıyor, common
// enums'a, alan dosyaları common'a. Barrel'da isim ÇAKIŞMASI olamaz —
// aynı adı iki dosya export ederse derleme kırılır ve bu iyi: iki alan aynı
// kavramı iki farklı şekilde tanımlamış demektir.

export * from './env.js';
export * from './enums.js';
export * from './locales.js';
export * from './auth.js';
export * from './plans.js';
export * from './common.js';
export * from './admin.js';

// ── Faz 1 alanları ────────────────────────────────────────────────────────
export * from './integrations.js';
export * from './analytics.js';
/// PDF raporunun başlık/metrik/durum adları — worker basıyor (13 dil).
export * from './export-copy.js';
/// `lastError` alanlarının biçimi — sunucu KOD yazar, ekran çevirir.
export * from './stored-error.js';
export * from './workspaces.js';
export * from './billing.js';
export * from './automation.js';
export * from './notifications.js';
// Kanal yetenek tablosu — tarayıcıya GİDEBİLİR ve gitmeli: tercih ekranı
// "bu kanal kişiye mi yazıyor", "kaç karakter" gibi soruları bu tablodan
// cevaplıyor. İçinde şablon, HTML ya da sır YOK.
//
// ⚠️ `notification-copy.ts` ve `notification-render.ts` BURADA YOK ve olmamalı:
// ikisi de sunucuya ait (metin gövdeleri, e-posta kabuğu, HTML temizleyici).
// Erişim `@mentorivo/shared/notification-render` alt yolundan — `mail.ts` ile
// aynı desen ve aynı gerekçe.
export * from './notification-channels.js';
/// Denetim kaydı → bildirim köprüsünün haritası. Burada: küçük, saf ve hem
/// API (köprü) hem test tarafından okunuyor. (`notification-copy` /
/// `notification-render` alt yolda kalıyor; onlar büyük metin tabloları.)
export * from './notification-audit.js';
/// Bildirim → panel rotası eşlemesi. Burada, çünkü hem arayüz (zil
/// listesindeki satırın adresi) hem sunucu (`mail.ts`, e-postadaki düğme)
/// aynı tabloyu okumak ZORUNDA — iki kopya vardı ve biri sessizce 404
/// üretiyordu (gerekçe dosyanın başında).
export * from './notification-route.js';
// ── Faz 3 ─────────────────────────────────────────────────────────────────
export * from './messaging.js';
export * from './agent.js';
/// Sohbet kartları (Faz 8, 30 Eyl 2026) — `AgentCard` birliği alan dosyalarına
/// bölündü; kart eylemi ve canlı veri sözleşmesi de burada (`agent-cards/index.ts`).
export * from './agent-cards/index.js';
/// Sohbetten bağlantı kartı (30 Eyl 2026) — platform listesi, durum türetimi
/// ve resmî kayıt adresleri; sunucu ve kart AYNI fonksiyonu okuyor.
export * from './agent-connect.js';
/// Ajanın web araştırması (1 Eki 2026) — kaynak bloğu, günlük tavan, adsız durum.
export * from './agent-web.js';
/// Canlı etkinlik paneli (1 Eki 2026) — okunur adımlar, SSE karesi, kalıcı özet.
export * from './agent-activity.js';
/// Asistan turunun SIRALI blok modeli (1 Eki 2026) — metin/kart/onay oluştuğu sırayla.
export * from './agent-reply-blocks.js';
/// Faz 9 X1 — kod çalıştırma, dosyalar (Files API), beceriler, günlük kod tavanı.
export * from './agent-code.js';
/// Faz 9 X2 — bellek aracı (`/memories` dizini, yol kemeri, tavanlar, kart satırı).
export * from './agent-memory.js';
/// Faz 7b — `app_op` kural eylemi: hangi ekran işlemi kurala bağlanabilir
/// (ajan sözlüğünün bayraklarından türüyor; editör de sunucu da okuyor).
export * from './automation-app-op.js';
/**
 * MANKEN KADROSU — `creative.js`ten ÖNCE ve bu sıra zorunlu.
 *
 * `creative.ts` buradan `presenterParamsSchema`yı DEĞER olarak alıyor.
 * Barrel bu satırı sonra değerlendirseydi şema `creative.ts` çalışırken
 * henüz tanımlı olmazdı (TDZ) — hata derlemede değil, ilk istekte çıkardı.
 *
 * Reçeteler (kim nasıl duruyor, ürünü nasıl tutuyor) BURADA DEĞİL:
 *     import { buildPresenterInstruction } from '@mentorivo/shared/studio-model-recipes';
 */
export * from './studio-models.js';
export * from './creative.js';
/// Maliyet önizlemesinin gövdesi — `studio.ts` döngüsü yüzünden ayrı dosyada.
export * from './creative-estimate.js';
/**
 * Kreatif işinin GERÇEK aşaması + ilerleme/kalan süre hesabı (Dalga 5b) —
 * sohbetin canlı üretim kartı, geçmiş kutusu ve worker'ın aşama yazımı aynı
 * saf fonksiyonu okuyor. Yalnız `enums.js` alıyor; sıra serbest.
 */
export * from './creative-progress.js';
/**
 * Kreatif direktörü sohbetinin UÇ sözleşmesi (21 Ağu 2026).
 *
 * BRIEF'İ burada değil (`./creative-director-brief.ts`, alt yoldan): modele
 * işi öğreten metin ürünün kendisi ve tüketicisi yalnız sunucu.
 *     import { buildDirectorSystemPrompt } from '@mentorivo/shared/creative-director-brief';
 */
export * from './creative-director.js';
/**
 * Beceri kataloğu — sohbetin giriş kapısı. `creative-director.js`ten SONRA:
 * reçeteler `DirectorForm` tipini okuyor.
 */
export * from './creative-skills.js';
export * from './brand-mockups.js';
export * from './agent-flows.js';
/**
 * Kampanya direktörü sohbetinin UÇ sözleşmesi (22 Ağu 2026).
 *
 * Kreatif direktörüyle AYNI desen ve aynı ayrım: brief burada DEĞİL
 * (`./campaign-director-brief.ts`, alt yoldan). İkisi ayrı sohbet ve ayrı
 * form — ortak tek şey günlük sayaç (`AgentLimitService`).
 */
export * from './campaign-director.js';
// ── Faz 4 ─────────────────────────────────────────────────────────────────
// `agent.js` ajanın SOHBET yüzü, `agents.js` KİMLİK yüzü. İsim çakışması
// olamaz (barrel derlemesi kırılır) — ikisi bilerek ayrı ad uzayları.
export * from './agents.js';

// ── Faz 5 ─────────────────────────────────────────────────────────────────
// Anahtar kelime / arama terimi okuma sözleşmesi. `analytics.js`ten AYRI
// çünkü platformdan bağımsız DEĞİL — Meta'da bu kavram yok.
export * from './keywords.js';
// RMF = kampanya/ad set/reklam OLUŞTURMA uçları. `analytics.js` aynı
// varlıkları OKUYOR ve DEĞİŞTİRİYOR; oluşturma ayrı bir dosyada çünkü girdisi
// tamamen farklı (hedefleme, faturalama olayı, kreatif) ve o alanların
// okuma sözleşmesinde hiçbir karşılığı yok.
export * from './rmf.js';

// ── Adım 4 — kampanya ekranları ───────────────────────────────────────────
// `analytics.js` ile `rmf.js` arasındaki BOŞLUKLAR. Yeni bir uç sözleşmesi
// değil: uçların hepsi zaten canlı, eksik olan o uçları tüketen ekranın
// kararlarıydı — hangi metrik hangi kapsamda anlamlı, seçim tavanı kaç,
// boş durumun dört hâlinden hangisi. Üç ekran (tablo, kolon seçici, rapor)
// o kararları ayrı ayrı yorumlarsa üç farklı davranış doğar.
export * from './campaigns.js';
// Sihirbaz `campaigns.js`ten AYRI ve gerekçesi `rmf.js`in `analytics.js`ten
// ayrılma gerekçesiyle aynı: okumanın girdisi filtre ve dönem, oluşturmanın
// girdisi hedefleme, faturalama olayı ve marka kimliği. Ortak alanları yok.
//
// 🔴 Bu dosya ELLE YAZILMIŞ kataloglar taşıyor (hedef, optimizasyon,
// faturalama olayı). Sözleşmeden türetilebilir olsalardı türetilirdi;
// değiller — `createCampaignSchema.objective` serbest bir dize ve hiçbir uç
// seçilebilir değerleri yayımlamıyor. Ayrım dosyanın başlığında yazılı.
export * from './campaign-wizard.js';

// Tek brief → çok platform (17 Eyl 2026). `campaign-wizard.ts`ten AYRI ve
// onun ÜSTÜNDE duruyor: orası platform seçildikten SONRAKİ formu tarif
// ediyor, burası platform seçilmeden ÖNCE sorulan tek girdiyi ve onu her
// platformun gövdesine çeviren derleyiciyi. Normalizasyon yalnız burada —
// `rmf.ts`in "normalize etme iddiası yok" kararı bozulmadan duruyor.
export * from './campaign-brief.js';

// Ajan kartlarının TASLAK yüzü (19 Eyl 2026): onay kartı artık sayfanın
// formu. `agent.js`ten AYRI ve brief'ten SONRA — `campaignBriefSchema` ile
// `creativeFormatIdSchema`yı DEĞER olarak alıyor; `agent.js` barrel'da o
// ikisinden önce değerlendiriliyor.
export * from './agent-draft.js';

// ── Faz 8 ─────────────────────────────────────────────────────────────────
// Demo veri modunun UÇ sözleşmesi. Veri ÜRETECİ (`demo-data.ts`) bilerek
// burada değil — `mail.ts` ile aynı gerekçe, alt yoldan okunuyor:
//     import { buildDemoDataset } from '@mentorivo/shared/demo-data';
export * from './demo.js';
// Destek bileti sözleşmesi. Yardım merkezi MAKALELERİ (`help-center.ts`)
// burada değil: 400 satır düz metin, tüketicisi yalnız API'nin `/help` ucu.
//     import { HELP_ARTICLES } from '@mentorivo/shared/help';
export * from './support.js';
// Blog SÖZLEŞMESİ — uç biçimi, konu listesi ve gövde blokları. Yazıların
// başlangıç METNİ burada değil (`./blog-seed.ts`, alt yoldan): tüketicisi
// yalnız tohum betiği ve iki dilde on iki yazı arayüz bundle'ına ait değil.
//     import { BLOG_SEED } from '@mentorivo/shared/blog-seed';
export * from './blog.js';

// Yasal metinlerin SÖZLEŞMESİ — dört belge, gövde blokları ve panel yazma
// biçimi. Metinlerin KENDİSİ burada değil (`./legal-seed.ts`, alt yoldan):
// iki dilde dört sözleşme ~70 KB ve tarayıcı bundle'ına ait değil.
//     import { LEGAL_SEED } from '@mentorivo/shared/legal-seed';
export * from './legal.js';

// Değişiklikler (`/changelog`) — sürüm günlüğünün sözleşmesi. Blogun ve yasal
// metnin üçüncü kardeşi ama gövdesi SERBEST DEĞİL: etiketli satırlar
// (gerekçe `changelog.ts` → `changelogChangeSchema`). Tohum METNİ yok —
// kayıtları yazan kişi ürün tarafı, bir betik değil.
export * from './changelog.js';

// ── ./mail BİLEREK BURADA DEĞİL ───────────────────────────────────────────
// `mail.ts` sunucunun gönderim anında kurduğu bildirim bağlantılarını taşıyor
// (posta şablonları 10 Eyl 2026'da `notification-render.ts`e geçti).
// `apps/web` bu barrel'ı import ediyor ve o içeriğin tarayıcıya gitmesi için
// hiçbir sebep yok. Erişim yalnız alt yoldan:
//
//     import { buildNotificationLink } from '@mentorivo/shared/mail';
//
// Buraya `export * from './mail.js'` eklemek ayrımı tek satırda siler.
// `packages/shared/src/mail-subpath.spec.ts` bunu doğruluyor.

// ── Genişleme Adım 1 ──────────────────────────────────────────────────────
// Mağaza bağlama, katalog, sipariş, stok. `integrations.js`ten AYRI ve
// gerekçesi dosyanın başlığında: mağazanın hiyerarşisi ve gün bazlı metriği
// YOK, buna karşılık kataloğu ve olay akışı VAR. Aynı dosyada tutmak iki
// kavramı birbirine karıştırırdı.
export * from './commerce.js';

// ── Genişleme Adım 7 ──────────────────────────────────────────────────────
// Video kreatif ekseni: süre, çözünürlük, en-boy oranı, ses, konuşma metni.
// `creative.js`ten AYRI ve gerekçesi dosyanın başlığında: bu altı alanın
// hiçbirinin görsel ya da metin üretiminde karşılığı yok, aynı dosyada
// tutmak alanların çoğu yalnız iki tipte anlamlı olan bir şema üretirdi.
export * from './video.js';

// ── ./video-templates BİLEREK BURADA DEĞİL ────────────────────────────────
// Şablon kataloğu prompt reçetelerinden ibaret ve tüketicisi SUNUCU: video
// hattı prompt'u ondan kuruyor, API uç noktası listesini döndürüyor. Arayüz
// kataloğu uçtan alıyor, bundle'dan değil. `./templates` (otomasyon) ve
// `./mail` ile aynı desen ve aynı gerekçe:
//
//     import { VIDEO_TEMPLATES } from '@mentorivo/shared/video-templates';

// ── Genişleme Adım 8 ──────────────────────────────────────────────────────
// Görsel stüdyo ekseni: sanal manken / kıyafet deneme, banner reçetesi,
// 2K büyütme, toplu üretim. `creative.js`ten AYRI ve gerekçesi dosyanın
// başlığında: bu modların hiçbiri yeni bir `CreativeType` açmıyor (üçü de
// AD_IMAGE ya da RESIZED üretiyor), ama her biri kendi eksenini getiriyor —
// manken tarifi, düzen bayrakları, büyütme hedefi. Aynı dosyaya koymak
// `creative.ts`i alanlarının çoğu yalnız üç modda anlamlı bir şemaya
// çevirirdi. `video.js` ile birebir aynı desen.
export * from './studio.js';

// ── ./banner-templates BİLEREK BURADA DEĞİL ───────────────────────────────
// Banner şablon kataloğu prompt reçetelerinden ibaret ve tüketicisi SUNUCU:
// stüdyo hattı prompt'u ondan kuruyor, `/creatives/studio/options` listesini
// döndürüyor. Arayüz kataloğu uçtan alıyor, bundle'dan değil.
// `./video-templates` ile aynı desen ve aynı gerekçe:
//
//     import { BANNER_TEMPLATES } from '@mentorivo/shared/banner-templates';

// ── Sahne şablonları — 19 Ağu 2026 ────────────────────────────────────────
// Görsel "reklam postu" reçeteleri. Barrel'da SÖZLEŞMESİ var, REÇETESİ yok ve
// ayrım bu adımın bütün sebebi: reçeteler o tarihe kadar
// `apps/web/src/lib/image-prompt-templates.ts` içinde, yani her ziyaretçinin
// indirdiği paketin İÇİNDE duruyordu.
//
//   · Kart tipleri (ad, açıklama, önizleme, yuva etiketleri) → burada, çünkü
//     arayüz `GET /creatives/studio/options` yanıtını bunlarla okuyor.
//   · Reçeteler → `@mentorivo/shared/scene-templates`, yalnız sunucu.
export * from './scene-public.js';

// ── ./scene-templates BİLEREK BURADA DEĞİL ────────────────────────────────
//     import { SCENE_TEMPLATES } from '@mentorivo/shared/scene-templates';

// ── Genişleme Adım 3 ──────────────────────────────────────────────────────
// Katalog zekâsı: ürün↔reklam köprüsü (feed kimliği ayrıştırma + deterministik
// eşleyici) ve ürün performans raporu sözleşmesi. `commerce.js`ten AYRI çünkü
// o dosya mağaza SENKRONUNU anlatıyor (bağlantı, okuma, webhook); buradakiler
// senkron bittikten SONRA katalogun üstünde çalışan kavramlar ve tüketicileri
// farklı — köprüyü worker, raporu API okuyor.
export * from './catalog.js';

// Katalog sağlığı kural listesi AYRI DOSYADA ve bilerek: "kural listesi tek
// yerde" bu adımın açık gereği, ayrı dosya o tekliği görünür kılıyor.
export * from './catalog-health.js';

// ── Genişleme Adım 9 — ticari operasyon ───────────────────────────────────
// Fatura profili: kimlik doğrulaması (TCKN/VKN checksum), telefon
// normalizasyonu, maskeleme ve sağlayıcıya giden `BuyerIdentity`. Doğrulama
// SÖZLEŞMEDE çünkü arayüz ile sunucu aynı kararı vermek zorunda — kullanıcı
// "kaydet"e basmadan önce yanlış numarayı öğrenebilmeli.
export * from './billing-profile.js';

// Para hareketinin KAYDI: tahsilat, iade, e-belge. `billing.js`ten ayrı —
// o dosya aboneliğin ve kredinin DURUMUNU anlatıyor, buradakiler olan biteni.
export * from './payments.js';

// Doğrudan ödeme (22 Eyl 2026): kart formu, 3DS akışı, kayıtlı kartlar,
// ödeme denemeleri. `billing.js` aboneliğin DURUMU, `payments.js` olan
// bitenin KAYDI, bu dosya ödemenin kendisi.
export * from './billing-pay.js';
/// Abonelik uyarısı (1 Eki 2026) — kabuk şeridi, günlük katman, hatırlatma takvimi.
export * from './billing-alert.js';

// Satış operasyonu: demo talebi hunisi + atanmış hesap yöneticisi.
// Burası BİZE gelen aday müşteri (kiracısı yok).
export * from './sales.js';

// ── Şema borç turu — kreatif onayı + içerik moderasyonu ───────────────────
// Adım 8'in borç olarak devrettiği iki kalem. `creative.js`ten AYRI: orası
// üretimi (prompt, format, kredi), burası üretim bittikten SONRA verilen
// KARARLARI anlatıyor — insanın onayı ve sağlayıcının/insanın moderasyon
// kaydı. İkisi tek dosyada çünkü onaycı kararını moderasyon satırlarına
// bakarak veriyor; ayırmak, birbirini okumadan anlamı olmayan iki sözleşme
// üretirdi.
export * from './moderation.js';

// ── Genişleme Adım 10 — rakip analizi ─────────────────────────────────────
// Meta Ad Library satır eşleyicisi (SAF: ağ/saat/DB yok), `ads_archive`
// sözleşmesi, Google Auction Insights tipleri ve /competitors uç şemaları.
//
// 🔴 Ad Library `connector/`ın ALTINDA DEĞİL ve bu bir düzen tercihi değil:
// uç, kiracının OAuth jetonunu değil KİMLİK ONAYLI bir platform jetonunu
// istiyor (14 Ağu 2026'da `code 10 / subcode 2332004` ile ölçüldü).
// Gerekçenin tamamı dosyanın başlığında.
export * from './competitor.js';

// ── Akış motoru — grafik sözleşmesi (schemaVersion 2) ─────────────────────
// `automation.js`ten AYRI ve gerekçesi dosyanın başlığında: doğrusal kural
// (tetikleyici → koşul → kapsam → sıralı aksiyon) ile grafik AYRI iki belge ve
// yan yana yaşıyorlar. Düğüm `data` şekilleri `automation.js`ten İMPORT
// EDİLİYOR, kopyalanmıyor — grafik ikinci bir sözleşme değil, aynı
// sözleşmenin ikinci bir DİZİLİMİ.
export * from './automation-graph.js';

// v1 ↔ v2 dönüştürücüleri. Barrel'da olması ŞART: kayıtlı kurallar hâlâ v1 ve
// motor yalnız grafik yürütüyor — API, worker ve editör aynı dönüşümü çağırmak
// zorunda. İkinci bir kopya, kuru çalıştırma ile gerçek koşunun farklı
// grafikler görmesi demekti.
export * from './automation-graph-convert.js';

// ── Ürün görseli analizi → ürüne özel video planı ─────────────────────────
// `video.js` videonun EKSENİNİ (oran/süre/çözünürlük/ses) tanımlıyor, burası
// o eksende ÜRETİLECEK ŞEYİ: ürün fotoğrafının okunması ve o okumadan çıkan
// çekim planı. Barrel'da çünkü planı arayüz DÜZENLİYOR — sahne şablonlarının
// aksine reçete sunucuda kalamıyor, kullanıcının ürününe özel üretiliyor ve
// üretim isteğiyle geri geliyor. Gerekçenin tamamı dosyanın başlığında.
export * from './product-vision.js';

// ── Prodüksiyon — reklam videosu motoru (Kreatif stüdyo Faz 2, 1 Eki 2026) ──
// SÖZLEŞME barrel'da: durum makinesi, aşama çıktılarının şemaları, eylem
// istekleri ve yanıt projeksiyonları — prodüksiyon sayfası ve sohbet kartı
// bunları okuyor. Yerleşim tablosu (`production-placements`) da burada:
// tezgâhın boyut/süre seçicisi onu çiziyor. `production.js` yerleşim
// dosyasından DEĞER alıyor, tersi yalnız tip — döngü yok.
//
// 🔴 MODEL ROTASI ve FİYAT burada DEĞİL (uç kimlikleri, USD) — alt yoldan:
//     import { SHOT_KIND_ROUTES, routeFor } from '@mentorivo/shared/production-routes';
//     import { usdToCredits, estimateProductionUsd } from '@mentorivo/shared/production-pricing';
export * from './production-placements.js';
export * from './production.js';
/**
 * Varyant A/B kararı (açılış/fikir seti) + `GET …/performance` yanıt tipi
 * (Dalga 5b'de API/worker ikiz dosyasından taşındı). `production.js` ve
 * `analytics.js`ten DEĞER alıyor, onlar buradan hiçbir şey almıyor.
 */
export * from './production-performance.js';

// ── Marka kiti + marka hafızası (Dalga 5, 2 Eki 2026) ──────────────────────
// MÜŞTERİNİN markası — `brand.ts` (Mentorivo'nun kendi logosu, alt yolda) ile
// karıştırma. Marka sayfası, sohbet aracı ve prodüksiyonun ANLA adımı okuyor.
export * from './brand-kit.js';

// ── Yayında AI içerik etiketi — tek okuyucu (Dalga 5) ──────────────────────
export * from './ai-content-label.js';

/// Backstage — platform yönetim paneli. Ürün sözleşmelerinden AYRI dosya:
/// buradaki tipler yalnızca backstage.mentorivo.com'da kullanılıyor ve
/// müşteri panelinin sözleşmeleriyle karışmamalı.
export * from './backstage.js';

/// Geliştirici API anahtarları — REST ve MCP sunucusunun kimliği. Anahtar
/// yönetim ekranı (panel) ile guard aynı biçimi ve aynı rol tavanını okuyor.
export * from './api-keys.js';

/// Canlı veri — tazelik ritmi ve ekrana itilen değişiklik olayları. Panel,
/// API ve worker aynı ritmi ve aynı konu listesini okuyor; gerekçe dosyanın
/// başlığında.
export * from './live.js';
export * from './operator.js';

/// Müşterinin KENDİ uzak MCP sunucuları (1 Eki 2026) — Anthropic MCP
/// bağlayıcısı (`mcp_servers` + `mcp_toolset`). Yönetim yalnız panelde.
export * from './mcp-connectors.js';
